import React from "react";
import { useModal } from "../../assets/useModal";
import { useDispatch, useSelector } from "react-redux";
import { findProductQuantity } from ".";
import QuantitySelector from "../../assets/QuantitySelector";
import { addProduct } from "../../actions/basket";
import LoginModal from "./LoginModal";
import AddOnList from "./AddOnList";

export default function Variant({ variant, product, onStartConfiguring }) {

	const { setModal } = useModal();
	const dispatch = useDispatch();
	const {
		basket,
		user,
		addOns,
		featureColor,
	} = useSelector(state => ({
		basket: state.basket,
		user: state.session.user && state.session.user.id ? state.session.user : null,
		addOns: state.vendor.addOns,
		featureColor: state.vendor.featureColor1
	}));

	const variantQuantity = findProductQuantity(variant, basket);
	const priceDifference = variant.price - product.price;

	return <div className="variant padded2 bordered-top">
		<div
			className="flexy wrapping"
			key={variant.id}
		>
			<div className="name" style={{ flex: 2, minWidth: 180 }}>
				<div className="featureFont" style={{ marginBottom: 10 }}>{variant.name}</div>
				{Boolean(variant.description) && <div className="description">
					{variant.description}
				</div>}
			</div>
			<div className="price text-right featureFont" style={{ minWidth: 90 }}>
				<div style={{ marginBottom: 10, paddingRight: 5 }}>
					{false && Boolean(priceDifference) ?
						<>
							<span style={{ marginLeft: 10 }}>£{(variant.price / 100).toFixed(2)}</span>
							{" "}
							<span
								className={priceDifference > 1 ? "more" : "less"}
								style={{
									whiteSpace: "pre",
									color: featureColor
								}}
							>
								[{priceDifference > 1 ? "+" : "-"}£{(Math.abs(priceDifference) / 100).toFixed(2)}]
						</span>
						</>
						:
						null
					}
					<span>
						<span>£{(variant.price / 100).toFixed(2)}</span>
					</span>
				</div>
				{Boolean(variant.options && variant.options.length) ?
					(
						<button
							className="style-2"
							onClick={e => {
								if (!user) {
									setModal(<LoginModal />, "login");
								} else {
									onStartConfiguring(product);
								}
							}}
						>Add<span className="brand-c">+</span></button>
					) : (
						<QuantitySelector
							showWhenDisabled={true}
							value={variantQuantity}
							onChange={newQuantity => {
								if (!user) {
									setModal(<LoginModal />);
								} else {
									dispatch(addProduct(variant, newQuantity - variantQuantity));
								}
							}}
						/>
					)
				}
			</div>
		</div>
		{/* Variant addons */}
		{Boolean(variantQuantity) && <AddOnList
			featureColor={featureColor}
			addOns={(variant.addOns || [])
				.map(addOn => ({ ...addOn, addOn: addOns.find(a => addOn.addOn === a.id) }))
				.filter(a => a.addOn)
			}
		/>}
	</div>
}